module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "name": "zip",
      "required": "required",
      "list": "ziplist"
    },
    domProps: {
      "value": _vm.id
    },
    on: {
      "change": _vm.ChangeEntry,
      "select": _vm.SelectEntry
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "ziplist"
    }
  }, _vm._l((_vm.content), function(entry) {
    return _c('option', {
      domProps: {
        "value": entry.id
      }
    }, [_vm._v(_vm._s(entry.text))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b71c0f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-search-input.vue
// module id = 455
// module chunks = 0